import dayjs from 'dayjs';
import {IError, IValues} from '../../types/interface/Assurance/assuranceRCVP';

export const showErrorValuesDefault = {
  nomPrenomContractant: false,
  dateNaissanceContractant: false,
  dateEffet: false,
  telephoneContractant: false,
  emailContractant: false,
  nombreAnimauxDomestique: false,
  adresse: false,
  agence: false,
  primeTTC: false,
};
export const showErrorValuesSubmit = {
  nomPrenomContractant: true,
  dateNaissanceContractant: true,
  dateEffet: true,
  telephoneContractant: true,
  emailContractant: true,
  nombreAnimauxDomestique: true,
  adresse: true,
  agence: true,
  primeTTC: true,
};

export const defaultErrorValues: IError = {
  nomPrenomContractant: '',
  dateNaissanceContractant: '',
  dateEffet: '',
  telephoneContractant: '',
  emailContractant: '',
  nombreAnimauxDomestique: '',
  adresse: '',
  agence: '',
  primeTTC: '',
  is_recurrent: '',
};
export const defaultValues: IValues = {
  nomPrenomContractant: '',
  dateNaissanceContractant: '',
  dateEffet: dayjs().format('DD/MM/YYYY'),
  telephoneContractant: '',
  telephoneContractantCountryCode: '',
  emailContractant: '',
  nombreAnimauxDomestique: '',
  adresse: '',
  agence: '',
  primeTTC: '',
  is_recurrent: false,
};

export const TitleLabels = {
  contractant: {
    nomPrenomContractant: 'Nom et prénom(s) du Contractant',
    dateNaissanceContractant: 'Date de naissance du Contractant ',
    telephoneContractant: 'Téléphone du Contractant',
    emailContractant: 'Email Contractant',
    nombreAnimauxDomestique: "Nombre d'animaux domestiques",
    adresse: 'Adresse ',
    agence: 'Agence ',
    primeTTC: 'Prime TTC à payer (en Ariary)',
    dateEffet: "Date d'effet",
  },
};

export const RCVP_PLACEMENT = 2;
